<div class="kt-footer kt-grid__item" id="kt_footer">
    <div [class]="containerClass" *ngIf="useBottomDiv">
        <div class="kt-footer__bottom">
            <div class="kt-footer__copyright pl-4">
                {{ "SIIWII" | localize }}   <span
                    *ngIf="appSession.tenant && appSession.tenant.edition && appSession.tenant.edition.displayName">
                    {{appSession.tenant.edition.displayName}}</span> | API: v{{appSession.application.version}} | Client: v{{webAppGuiVersion}}
            </div>
        </div>
    </div>
    <div [class]="containerClass" *ngIf="!useBottomDiv">
        <div class="kt-footer__wrapper">
            <div class="kt-footer__copyright pl-4">
                {{ "SIIWII" | localize }} <span
                    *ngIf="appSession.tenant && appSession.tenant.edition && appSession.tenant.edition.displayName">
                    {{appSession.tenant.edition.displayName}}</span> | API: v{{appSession.application.version}} | Client: v{{webAppGuiVersion}}
            </div>
        </div>
    </div>
</div>
